"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Phone, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForTheNextLevel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="135138" id="ready-to-recover" className="dark bg-[#1A1A2E] text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-[#3B8FD4]/80 via-[#1A1A2E] to-[#1A1A2E] opacity-95 pointer-events-none" />
      
      {}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-20 pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 relative z-10 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-5xl md:text-[64px] font-serif font-medium tracking-tight text-white mb-10 leading-none drop-shadow-2xl">
          Ready to start your journey?
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto h-16 px-12 bg-white text-[#1A1A2E] hover:bg-white/95 text-lg font-sans font-bold uppercase tracking-wider shadow-2xl hover:shadow-[#3B8FD4]/30 transition-all rounded-full">
            <Link to="https://bodywerkscy.setmore.com">
              <SafeHydrate><Calendar className="mr-2 size-6" /></SafeHydrate>
              Book Your Appointment
            </Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="w-full sm:w-auto h-16 px-12 border-2 border-white bg-transparent text-white hover:bg-white/10 text-lg font-sans font-bold uppercase tracking-wider shadow-xl transition-all rounded-full">
            <Link to="tel:+35725333333">
              <Phone className="mr-2 size-6" />
              Call Us Now
            </Link>
          </Button>
        </div>

        <div className="flex flex-col items-center space-y-4">
          <span className="text-sm font-sans font-medium text-white/80 uppercase tracking-widest">
            Direct access to our Cyprus clinics
          </span>
          <Link to="tel:+35725954014" className="inline-flex items-center gap-3 text-4xl md:text-5xl font-serif font-medium text-white hover:text-[#3B8FD4] transition-colors duration-300 drop-shadow-md">
            +357 25 954 014
          </Link>
        </div>
      </div>
    </section>;
}